/** @jsxImportSource @emotion/react */
import type { Theme, css } from '@emotion/react'

import type { BlocksDownloadComponent } from '@twisto/api-cms'

import { StoreButton, StrapiMedia } from 'homepage/components/atoms'
import { Hidden } from 'homepage/components/atoms/hidden'

import * as widgetStyles from './secondary.styles'

type DownloadWidgetProps = {
  styles?: (theme: Theme) => ReturnType<typeof css>
}

export const SecondaryDowndloadWidget = ({
  headline,
  src,
  stores,
  styles,
}: BlocksDownloadComponent & DownloadWidgetProps) => (
  <div css={[widgetStyles.download, widgetStyles.container, styles]}>
    <Hidden breakpoint="smDown" css={widgetStyles.container}>
      <StrapiMedia {...src} css={widgetStyles.qrCode} />
      <h4 css={widgetStyles.headline}>{headline}</h4>
    </Hidden>

    <div css={widgetStyles.stores}>
      {stores?.map(({ id, storeLogo, url }) => (
        <StoreButton key={id} storeLogo={storeLogo} url={url} />
      ))}
    </div>
  </div>
)
